import { SuccessFilled } from '@zeelool/icon';
import { useTranslations } from '@/i18n/use-translations';
import Image from '@/components/Image';
import { useScanInfo } from './useScanInfo';
import Upload from '@/components/Upload';
import Button from '@/components/Button';
import { useState } from 'react';

export default function ScanPrescriptionM({
  // isShowPrismInfo,
  // setIsShowPrismInfo,
  onFileUpload,
  onClickUpload,
  onStartUpload,
}: {
  // isShowPrismInfo?: boolean;
  // setIsShowPrismInfo: (isShowPrismInfo: boolean) => void;
  onFileUpload?: (fileUrl: string) => void;
  onClickUpload?: (buttonType: 'Upload' | 'Photo') => void;
  onStartUpload?: () => void;
}) {
  const t = useTranslations('lens-process');
  const { incorrectExamples, prescriptionInfo } = useScanInfo('font-be');
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [isUploadingPhoto, setIsUploadingPhoto] = useState(false);

  // 处理上传图片按钮的上传状态
  const onUploadImageChange = (isUploading: boolean) => setIsUploadingImage(isUploading);
  // 处理拍照按钮的上传状态
  const onUploadPhotoChange = (isUploading: boolean) => setIsUploadingPhoto(isUploading);
  return (
    <div className="w-full mx-auto flex flex-col bg-gray-100 min-h-screen overflow-hidden  ">
      {/* Header */}
      <div className="px-14 f20 mb-[20px] font-bb text-[#333333]">
        {t('scanPrescription.title')}
      </div>

      {/* Main Content */}
      <main className="bg-white rounded-t-3xl pt-16 px-14 flex-1 pb-[38px]">
        {/* Description */}
        <p className="text-[13px]/[15px] text-[#282828] mb-12">
          {t('scanPrescription.description')}
        </p>

        {/* Prescription Example */}
        <div className="w-full relative mb-20 h-[150px]">
          <Image src="/lens-process/correct-example.png" alt="" fill />
          <SuccessFilled className="absolute top-[6px] right-[6px] text-[20px] border-2 rounded-full bg-white border-white text-[#299373]" />
        </div>

        {/* Requirements */}
        <div className="text-[13px]/[15px] mb-40 flex flex-col gap-12">
          {prescriptionInfo.map((info, index) => (
            <div key={index} className="text-[#282828] text-[13px]/[15px]">
              {info}
            </div>
          ))}
        </div>

        {/* Incorrect Operation */}
        <div className="mb-25">
          <div className="flex items-center gap-6 mb-12">
            <div className="w-[16px] h-[16px] bg-[#bc1b1b] rounded-full text-white text-bold  flex items-center justify-center">
              <div className="w-[10px] h-[2px] bg-white " />
            </div>
            <div className="text-14 font-be">{t('scanPrescription.incorrectTitle')}</div>
          </div>

          {/* Examples Grid */}
          <div className="flex gap-8">
            {incorrectExamples.map((example, index) => (
              <div
                key={index}
                className="h-[70px] flex-1 rounded-lg relative overflow-hidden shadow-sm"
              >
                <Image src={example.image} alt={example.label} fill className="object-cover" />
                <div className="absolute inset-x-0 bottom-0 bg-[rgba(0,0,0,0.5)] text-white text-11 text-center px-4 py-4">
                  {example.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Prism Values */}
        <section className="mb-[8px]">
          <div className="flex items-center justify-between">
            <h3 className="text-14 font-be mb-8">{t('havePrismValues')}</h3>
          </div>
          <div className="text-13 text-[#808080]">
            {t('theScanCannotCapturePrismValuesPleaseManuallyInputBasedOnYourPrescriptionIfNoted')}
          </div>
        </section>

        {/* Action Buttons */}
        <div className="fixed h-[70px] bottom-0 left-0 right-0 bg-white shadow-lg px-16 py-14 flex gap-12 z-100 items-center max-xl:shadow-[0px_-1px_5px_0px_rgba(204,204,204,0.5)]">
          {/* Upload Image Button */}
          <Upload
            sceneId={2}
            fileType="image"
            accept="image/jpeg,image/png,image/jpg"
            className="!mt-0 flex-1"
            toastConfig={{ success: false, fail: true }}
            sx={{
              '& .MuiBox-root': {
                width: '100%',
                height: '42px',
              },
            }}
            onClickUpload={() => {
              onClickUpload?.('Upload');
            }}
            onStartUpload={onStartUpload}
            onChange={onFileUpload}
            onUploadChange={onUploadImageChange}
          >
            <Button
              loading={isUploadingImage}
              variant="contained"
              fullWidth
              className="!font-bold !h-[42px] !bg-[#282828] !text-white !rounded-[21px] hover:!bg-[#404040]"
              sx={{
                '&.MuiButton-root': {
                  backgroundColor: '#282828',
                  '&:hover': {
                    backgroundColor: '#404040',
                  },
                },
              }}
            >
              {t('uploadImage')}
            </Button>
          </Upload>

          {/* Take Photo Button */}
          <Upload
            sceneId={2}
            fileType="image"
            accept="image/jpeg,image/png,image/jpg"
            className="!mt-0 flex-1"
            toastConfig={{ success: false, fail: true }}
            sx={{
              '& .MuiBox-root': {
                width: '100%',
                height: '42px',
              },
            }}
            capture="environment"
            onChange={onFileUpload}
            onClickUpload={() => {
              onClickUpload?.('Photo');
            }}
            onStartUpload={onStartUpload}
            onUploadChange={onUploadPhotoChange}
          >
            <Button
              loading={isUploadingPhoto}
              variant="contained"
              fullWidth
              className="!font-bold !h-[42px] !rounded-[21px]"
            >
              {t('takePhoto')}
            </Button>
          </Upload>
        </div>
      </main>
    </div>
  );
}
